module.exports = __webpack_public_path__ + "static/media/materialCard-min.f96fd36a.png";